<header>
  <h2 style="padding-right: 50px">Consulta Póliza Matrícula Prima</h2>
  <span style="flex: 1 1 auto;"></span>
  <h2 id="btnCerrar" mat-flat-button style="margin-right: 20px; padding-left: 50px;" (click)="onClose()" >X</h2>
</header>
<mat-dialog-content style="padding-bottom: 20px;">
  <form [formGroup]="busquedaForm" (ngSubmit)="buscar()">
    <fieldset [disabled]="buscando">
      <label>
        Matrícula<br>
        <input type="text" matInput autofocus formControlName="matricula"><br>
      </label>
    </fieldset>
    <fieldset [disabled]="buscando">
      <label>
        Poliza<br>
        <input type="text" matInput autofocus formControlName="poliza"><br>
      </label>
    </fieldset>
    <fieldset [disabled]="buscando">
      <label>
        Fecha Siniestro<br>
        <input type="date" matInput autofocus formControlName="claimDate"><br>
      </label>
    </fieldset>
    <footer style="width: 20%">
      <button
          name="buscar"
          type="submit"
          style="width: 100%"
          formnovalidate
          mat-flat-button
          class="btnCCOscuro"
          [disabled]="! busquedaForm.valid || buscando"
          >Buscar</button>
    </footer>
  </form>
</mat-dialog-content>
